import React, { useEffect } from 'react';
import Footer from '@/components/Footer';
import Logo from '@/assets/logo.svg';
import LoginForm from './form';
import LoginBanner from './banner';
import styles from './style/index.module.less';

function Login() {
  useEffect(() => {
    document.body.setAttribute('arco-theme', 'light');
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: styles.container
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.logo
  }, /*#__PURE__*/React.createElement(Logo, null), /*#__PURE__*/React.createElement("div", {
    className: styles['logo-text']
  }, "\u996D\u5212\u7B97")), /*#__PURE__*/React.createElement("div", {
    className: styles.banner
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['banner-inner']
  }, /*#__PURE__*/React.createElement(LoginBanner, null))), /*#__PURE__*/React.createElement("div", {
    className: styles.content
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['content-inner']
  }, /*#__PURE__*/React.createElement(LoginForm, null)), /*#__PURE__*/React.createElement("div", {
    className: styles.footer
  }, /*#__PURE__*/React.createElement(Footer, null))));
}

Login.displayName = 'LoginPage';
export default Login;